import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
});

// Injeta token JWT em todas as requisições
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('chatmj_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redireciona para login se token expirar
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('chatmj_token');
      localStorage.removeItem('chatmj_usuario');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const login = (email, senha) =>
  api.post('/auth/login', { email, senha });

// Usuários
export const listarUsuarios  = ()         => api.get('/usuarios');
export const criarUsuario    = (dados)    => api.post('/usuarios', dados);
export const atualizarUsuario= (id, dados)=> api.put(`/usuarios/${id}`, dados);
export const removerUsuario  = (id)       => api.delete(`/usuarios/${id}`);

// Conversas
export const listarConversas  = (params)  => api.get('/conversas', { params });
export const buscarMensagens  = (id)      => api.get(`/conversas/${id}/mensagens`);
export const enviarMensagem   = (id, texto) => api.post(`/conversas/${id}/enviar`, { texto });
export const transferirConversa=(id, atendente_id) => api.post(`/conversas/${id}/transferir`, { atendente_id });
export const resolverConversa = (id)      => api.post(`/conversas/${id}/resolver`);
export const enviarAudioApi = (id, audioBase64) => api.post(`/conversas/${id}/audio`, { audioBase64 });

// Relatórios
export const buscarRelatorios = () => api.get('/relatorios');

// Status instâncias
export const statusInstancias = () => api.get('/status');

export default api;
